<template>
    <rkm-overlay>
        <rkm-layout-body title="Tabela OBM">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/parametrizacao/tabela-obm/List'

export default {
    components: {List},
}
</script>